var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('loading-progress',{attrs:{"indeterminate":"","fill-duration":"2","shape":"line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }